var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.isShow,"title":"付款"},on:{"ok":_vm.doPay,"cancel":_vm.handleClose,"finish":_vm.doPay}},[_vm._v("\n    是否确认付款，付款费用将从余额中扣除,付款后可在账户信息中查看账户流水\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95f683c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/deal/third/components/BatchPay.vue
// module id = null
// module chunks = 